var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.openOverlay}},[_vm._v("Open Overlay")]),(_vm.isOverlayOpen)?_c('AppOverlay'):_vm._e(),(_vm.isOverlayOpen)?_c('button',{staticClass:"close-overlay-button",on:{"click":_vm.closeOverlay}},[_vm._v(" Close Overlay ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }